import { Pipe, PipeTransform } from "@angular/core";

import * as math from "mathjs";

@Pipe({
  name: "format",
})
export class FormatPipe implements PipeTransform {
  transform(input: string, option: string = "default"): string {
    switch (option) {
      case "hidden":
        return input.replace(/\d/g, "*");
      case "default":
      default:
        return input.replace(/\*/g, "×");
        break;
    }
  }
}
